module.exports = __webpack_public_path__ + "static/media/hospital-alt.90e13b38.svg";